<template>
  <div class="not-found">
    <div class="container-fluid">
      <div class="row">
        <div class="col-xs-12 col-sm-8 col-md-6 offset-sm-0 offset-sm-2 offset-md-3">
          <div class="card">
            <div class="card-body text-center">
              <h1 class="card-title">
                404
              </h1>
              <h2 class="card-subtitle">
                Page not found :(
              </h2>
              <p class="card-subtitle">
                The page you are looking for doesn't exist or an other error occured.
              </p>
              <p class="card-subtitle">
                Head over to 
                <router-link
                  :to="{ name: 'Dashboard' }"
                >
                  {{hostname}}
                </router-link>
                 to choose a new direction.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      hostname: location.hostname,
    };
  },
};
</script>

<style scoped lang="scss">
.not-found {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f2f7f8;
  min-height: 100vh;
}
.not-found-card-wrapper {
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/NotFound/NotFound.vue